import { createUsuarioApi } from "@/contexts/autorizacao/usuario/api/usuarioApi";
import { UsuarioLogado } from "@/contexts/autorizacao/usuario/model/UsuarioLogado";
import {
  getUser,
  usuarioLogadoAction,
} from "@/contexts/autorizacao/usuario/store/usuarioLogadoSlice";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useUsuarioLogado = () => {
  const { user } = useAuth();
  const usuarioApi = createUsuarioApi(user?.access_token);
  const appDispatch = useDispatch();
  const usuarioLogado = useSelector(getUser);
  const { add, remove } = usuarioLogadoAction;

  const removeUsuarioLogado = () => {
    appDispatch(remove());
  };

  const sincronizarUsuarioLogado = (usuario: UsuarioLogado) => {
    appDispatch(add(usuario));
  };

  const getUsuarioLogadoApi = usuarioApi.getMe;

  return {
    usuarioLogado,
    sincronizarUsuarioLogado,
    removeUsuarioLogado,
    getUsuarioLogadoApi,
  };
};
